"use client";
import { jsx as _jsx } from "react/jsx-runtime";
import { DrawerBody, DrawerCloseButton, DrawerContent, DrawerHeader, DrawerOverlay, DrawerRoot, DrawerTitle, Drawer as MantineDrawer, factory, useProps, } from "@mantine/core";
// Base styles, must come first
import "@mantine/core/styles/CloseButton.layer.css";
import "@mantine/core/styles/ModalBase.layer.css";
import "@mantine/core/styles/Overlay.layer.css";
import "@mantine/core/styles/Paper.layer.css";
import "@mantine/core/styles/Drawer.layer.css";
import * as styles from "./Drawer.module.css";
const Drawer = factory((props, ref) => {
    const modifiedProps = useProps("Drawer", {
        classNames: styles,
    }, props);
    return _jsx(MantineDrawer, { ...modifiedProps, ref: ref });
});
Drawer.displayName = "Drawer";
DrawerBody.displayName = "DrawerBody";
DrawerCloseButton.displayName = "DrawerCloseButton";
DrawerContent.displayName = "DrawerContent";
DrawerHeader.displayName = "DrawerHeader";
DrawerOverlay.displayName = "DrawerOverlay";
DrawerRoot.displayName = "DrawerRoot";
DrawerTitle.displayName = "DrawerTitle";
Drawer.Body = DrawerBody;
Drawer.CloseButton = DrawerCloseButton;
Drawer.Content = DrawerContent;
Drawer.Header = DrawerHeader;
Drawer.Overlay = DrawerOverlay;
Drawer.Root = DrawerRoot;
Drawer.Title = DrawerTitle;
export { Drawer, };
//# sourceMappingURL=Drawer.js.map